<template>
    <transition name="modal-fade">
        <div class="modal-backdrop">
            <div class="modal"
                 role="dialog"
                 aria-labelledby="modalTitle"
                 aria-describedby="modalDescription"
            >
                <header
                    class="modal-header"
                    id="modalTitle"
                >
                    <h5 class="modal-title">{{ title }}</h5>
                    <button
                        type="button"
                        class="btn-close"
                        @click="close"
                        aria-label="Close modal"
                    >
                        x
                    </button>
                </header>

                <section
                    class="modal-body"
                    id="modalDescription"
                >
                    <slot name="body">
                        This is the default body!
                    </slot>
                </section>

                <footer class="modal-footer">
                    <div class="text-left">
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="close"
                            aria-label="Close modal"
                        >
                            Close
                        </button>
                        <slot name="footer">

                        </slot>
                    </div>
                </footer>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['title'],
    name: "Modal",
    methods: {
        close() {
            this.$emit("close");
        }
    }
};
</script>

<style scoped>
.modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
}

.modal {
    background: #ffffff;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;

    position: unset;

    min-width: 50%;
    max-height: 90%;
    height: auto;
    max-width: 80%;
    width: auto;
}

.modal-header,
.modal-footer {
    padding: 15px;
    display: flex;
    align-items: flex-end;
}

.modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #ff3636;
    justify-content: space-between;
}

.modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
}

.modal-body {
    position: relative;
    padding: 20px 10px;
    overflow-y: scroll;
}

.btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #ff3636;
    background: transparent;
}

.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity 0.5s ease;
}

.btn {
    display: inline-block !important;
}
</style>
